import React from 'react';
import { common, ScreenProps } from '@fnol/library/src/lib';
import { Button } from '@fnol/library/src/components';
import Box from '@mui/material/Box';
import { translations } from '../../lib/consts';
import { Typography } from '@mui/material';

export const SecondMessage = ({ navigator }: ScreenProps) => {
    const [currentStep, { goForward, goBack }] = navigator;
    return (
        <>
            <Box sx={{ width: '100%', height: 400, paddingTop: '15px' }}>
                <Box sx={{ width: '100%', height: 400, paddingTop: '15px' }}>
                    <Typography>
                        <h2>{translations.intro.INTRO_MESSAGE_2_TITLE}</h2>
                        <p style={{ fontSize: '1.1rem' }}>{translations.intro.INTRO_MESSAGE_2_INTRO}</p>
                        <ul style={{ fontSize: '1.1rem' }}>
                            <li>{translations.intro.INTRO_MESSAGE_2_LINE_1}</li>
                            <li>{translations.intro.INTRO_MESSAGE_2_LINE_2}</li>
                            <li>{translations.intro.INTRO_MESSAGE_2_LINE_3}</li>
                        </ul>
                        <p style={{ fontSize: '1.1rem' }}>{translations.intro.INTRO_MESSAGE_2_REMARK}</p>
                    </Typography>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', paddingTop: '15px' }}>
                <Button onClickHandler={goBack} label={common.PREVIOUS} />
                <Button onClickHandler={goForward} label={common.NEXT} />
            </Box>
        </>
    );
};
